import Container from './Container'
export default Container



// WEBPACK FOOTER //
// ./src/Containers/Campaigns/index.js